<div class="admin-data-source-dialog" [class.inline-mode]="inline">
  <div class="admin-data-source-dialog__header">
    <h1 *ngIf="!inline" mat-dialog-title class="admin-data-source-dialog__header-title">
      <ng-container *ngIf="currentDataSource; else addTitle" i18n="Dialog Title@@adminDataSourceEditTitle">Edit Data Source</ng-container>
      <ng-template #addTitle>
        <ng-container i18n="Dialog Title@@adminDataSourceAddTitle">Add Data Source</ng-container>
      </ng-template>
    </h1>

    <mat-icon *ngIf="showCloseButton && !inline" class="admin-data-source-dialog__header-btn" mat-dialog-close="false">close</mat-icon>
  </div>

  <div mat-dialog-content>

	<mat-tab-group mat-stretch-tabs anchorSelectedTab (selectedTabChange)="onChangeTab($event)" class="admin-data-source-editor">
		<mat-tab label="Builder" i18n-label="External Data Sources Tab Builder Label@@adminExternalDataSourcesViewBuilderLabel">
			<div class="pt-2 mr-2" *ngIf="currentTabIndex === 0">
				<div [formGroup]="form" class="admin-data-source-dialog__form">
					<div class="admin-data-source-dialog__group">
						<app-text-input class="admin-data-source-dialog__name_input" label="Name" i18n-label="Name Label@@adminDataSourceNameLabel"
										[parentForm]="form"
										[controlName]="'name'"
										[fullWidth]="true"
										[showLocale]="true"
										[localeData]="form.value.locale?.name"
										(localeChange)="updateDatasourceNameLocale($event)"
						></app-text-input>
					</div>

					<div class="admin-data-source-dialog__group" *ngIf="currentDataSource?.slug">
						<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input" appearance="fill">
							<mat-label i18n="Slug Label@@adminDataSourceSlugLabel">Slug</mat-label>
							<input matInput formControlName="slug"/>
						</mat-form-field>
					</div>

					<div class="admin-data-source-dialog__group">
						<mat-form-field class="no-underline form-field dark-color admin-data-source-dialog__input" floatLabel="never" appearance="fill">
							<mat-label i18n="Connector Type Label@@adminDataSourceConnectorTypeLabel">Connector Type</mat-label>
							<mat-select formControlName="connectorType" required>
								<mat-option *ngFor="let type of DataSourceConnectorType | keyvalue" [value]="type.value">{{ type.key }}</mat-option>
							</mat-select>
						</mat-form-field>
					</div>

					<div class="admin-data-source-dialog__group">
						<app-select-input
							class="block full-width"
							[options]="isSuperAdmin ? ([{ value: 'ALL', label: 'All' }].concat(businessOptions)) : businessOptions"
							[optionValueKey]="'value'"
							[optionLabelKey]="'label'"
							[currentValue]="selectedBusinessIds"
							[fullWidth]="true"
							[showSearch]="true"
							[multiple]="true"
							[label]="(siteCopy$ | async)?.businessNameLabelPlural || 'Businesses'"
							i18n-label="Data Source Dialog Businesses@@dataSourceDialogBusinessesLabel"
							[hint]="'Select which ' + ((siteCopy$ | async)?.businessNameLabelPlural?.toLowerCase() || 'businesses') + ' this data source belongs to' + (isSuperAdmin ? '' : '. At least one must be selected.')"
							i18n-hint="Data Source Dialog Businesses Hint@@dataSourceDialogBusinessesHint"
							(valueChange)="onBusinessSelectionChange($event)"
						></app-select-input>
					</div>

					<div class="admin-data-source-dialog__group" *ngIf="adminMode$ | async">
						<app-toggle-input
							[currentValue]="form.get('public').value"
							label="Public"
							i18n-label="Public Label@@adminDataSourcePublicLabel"
							hint="Make this data source publicly accessible"
							i18n-hint="Public Hint@@adminDataSourcePublicHint"
							(valueChange)="form.get('public').setValue($event)"
						></app-toggle-input>
					</div>

					<ng-container formGroupName="config">
						<div class="admin-data-source-dialog__group mt-2">
							<span class="admin-data-source-dialog__title" i18n="Configuration Title@@adminDataSourceConfigurationTitle">Configuration</span>
						</div>

						<ng-container [ngSwitch]="form.get('connectorType').value">
							<div class="admin-data-source-dialog__group" *ngSwitchCase="DataSourceConnectorType.CSV">
								<div class="form-group-element">
									<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width" appearance="fill">
										<mat-label i18n="Asset Path Label@@adminDataSourceAssetPathLabel">Asset Path</mat-label>
										<input matInput formControlName="target" placeholder="Asset Path" i18n-placeholder="Asset Path Placeholder@@adminDataSourceAssetPathPlaceholder"/>
									</mat-form-field>
									<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width" appearance="fill">
										<mat-label i18n="Column Separator Label@@adminDataSourceColumnSeparatorLabel">Column Separator</mat-label>
										<input matInput formControlName="columnSeparator" placeholder="Column Separator" i18n-placeholder="Column Separator Placeholder@@adminDataSourceColumnSeparatorPlaceholder"/>
									</mat-form-field>
								</div>
							</div>
							<div class="admin-data-source-dialog__group" *ngSwitchCase="DataSourceConnectorType.SmartSheet">
								<div class="form-group-element">
									<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width" appearance="fill">
										<mat-label i18n="Worksheet ID Label@@adminDataSourceWorksheetIdLabel">Worksheet ID</mat-label>
										<input matInput formControlName="target" placeholder="Worksheet ID" i18n-placeholder="Worksheet ID Placeholder@@adminDataSourceWorksheetIdPlaceholder"/>
									</mat-form-field>

									<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width" appearance="fill">
										<mat-label i18n="Access Token Label@@adminDataSourceAccessTokenLabel">Access Token</mat-label>
										<input matInput formControlName="accessToken" placeholder="Access Token" i18n-placeholder="Access Token Placeholder@@adminDataSourceAccessTokenPlaceholder"/>
									</mat-form-field>
								</div>
								<div class="form-group-element">
									<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width" appearance="fill">
										<mat-label i18n="Admin Data Source Smartsheet Url@@adminDataSourceLinkLabel">Smartsheet Link</mat-label>
										<input matInput [disabled]="true" formControlName="sourceLink" placeholder="Smartsheet link will be generated here" i18n-placeholder="Access Token Placeholder@@adminDataSourceAccessTokenPlaceholder"/>
										<mat-icon matSuffix class="pointer" (click)="copyToClipboard()">content_copy</mat-icon>
									</mat-form-field>
								</div>
							</div>
							<div class="admin-data-source-dialog__group" *ngSwitchCase="DataSourceConnectorType.Cloudinary">
								<div class="form-group-element">
									<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width" appearance="fill">
										<mat-label i18n="Path structure for Cloudinary Label@@adminDataSourcePathStructureForCloudinaryLabel">Path structure for Cloudinary</mat-label>
										<input matInput formControlName="target" placeholder="Path structure for Cloudinary" i18n-placeholder="Path structure for Cloudinary Placeholder@@adminDataSourcePathStructureForCloudinaryPlaceholder"/>
									</mat-form-field>
								</div>
								<div class="form-group-element">
									<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width" appearance="fill">
										<mat-label i18n="Environment Label@@adminDataSourceEnvironmentLabel">Environment</mat-label>
										<input matInput formControlName="environment" placeholder="Environment" i18n-placeholder="Environment Placeholder@@adminDataSourceEnvironmentPlaceholder"/>
									</mat-form-field>

									<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width" appearance="fill">
										<mat-label i18n="Access Token Label@@adminDataSourceAccessTokenLabel">Access Token</mat-label>
										<input matInput formControlName="accessToken" placeholder="Access Token" i18n-placeholder="Access Token Placeholder@@adminDataSourceAccessTokenPlaceholder"/>
									</mat-form-field>
								</div>
							</div>
							<div class="admin-data-source-dialog__group" *ngSwitchCase="DataSourceConnectorType.Strapi">
								<div class="form-group-element">
									<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width" appearance="fill">
										<mat-label i18n="Collection Label@@adminDataSourceCollectionLabel">Collection</mat-label>
										<input matInput formControlName="target" placeholder="Collection" i18n-placeholder="Collection Placeholder@@adminDataSourceCollectionPlaceholder"/>
									</mat-form-field>
								</div>
							</div>
							<div class="admin-data-source-dialog__group" *ngSwitchCase="DataSourceConnectorType.Pexels">
								<div class="form-group-element">
									<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width" appearance="fill">
										<mat-label i18n="Default Search@@adminDataSourceSearchQueryLabel">Default Search Query</mat-label>
										<input matInput formControlName="target" placeholder="Search Query" i18n-placeholder="Search Query Placeholder@@adminDataSourceSearchQueryPlaceholder"/>
									</mat-form-field>

									<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width" appearance="fill">
										<mat-label i18n="API Key Label@@adminDataSourceAPIKeyLabel">API Key</mat-label>
										<input matInput formControlName="accessToken" placeholder="API Key" i18n-placeholder="API Key Placeholder@@adminDataSourceAPIKeyPlaceholder"/>
									</mat-form-field>
								</div>

							</div>
							<div class="admin-data-source-dialog__group" *ngSwitchCase="DataSourceConnectorType.Bria">
								<div *ngIf="form.get('config.useBriaIframe')" class="form-group-element mb-3">
									<app-toggle-input
										[currentValue]="form.get('config').get('useBriaIframe').value"
										label="Use Bria Iframe"
										i18n-label="Use Bria Iframe@@adminDataSourceUseBriaIframeLabel"
										hint="Opens the Bria iframe instead of using our text to image interface"
										(valueChange)="form.get('config').get('useBriaIframe').setValue($event)"
									></app-toggle-input>
								</div>

								<div *ngIf="form.get('config.useBriaIframe')?.value" class="form-group-element">
									<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width" appearance="fill">
										<mat-label i18n="Iframe Id or Url@@adminDataSourceIframeIdOrUrlLabel">Iframe ID or URL</mat-label>
										<input matInput formControlName="target" placeholder="Iframe Id or URL" i18n-placeholder="Iframe ID or Url Placeholder@@adminDataSourceIframeIdOrUrlPlaceholder"/>
									</mat-form-field>
								</div>

								<div *ngIf="!form.get('config.useBriaIframe')?.value && form.get('config').get('models')" class="form-group-element">
									<app-multi-add-input
										class="block full-width"
										[currentValue]="form.get('config').get('models').value"
										label="Models to pick from"
										i18n-label="Models to Pick from@@adminDataSourceModelsPickerLabel"
										keyLabel="Name"
										keyProperty="name"
										valueLabel="Model ID/URL"
										dataType="array"
										[fullWidth]="true"
										(valueChange)="form.get('config').get('models').setValue($event)"
									></app-multi-add-input>
								</div>
							</div>
							<div class="admin-data-source-dialog__group" *ngSwitchCase="DataSourceConnectorType.Brandshare">
								<div class="form-group-element">
									<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width" appearance="fill">
										<mat-label i18n="Brandshare List ID@@adminDataSourceBrandshareListIdLabel">List ID</mat-label>
										<input matInput formControlName="target" placeholder="67dabb530a77601219bdac87" i18n-placeholder="Brandshare List ID Placeholder@@adminDataSourceBrandshareListIdPlaceholder"/>
									</mat-form-field>
								</div>
								<div class="form-group-element">
									<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width" appearance="fill">
										<mat-label i18n="API Key (Optional)@@adminDataSourceApiKeyOptionalLabel">API Key (Optional)</mat-label>
										<input matInput type="password" formControlName="apiKey" placeholder="Your Brandshare API Key (or use environment variable)" i18n-placeholder="API Key Optional Placeholder@@adminDataSourceApiKeyOptionalPlaceholder"/>
									</mat-form-field>
								</div>
								<div class="form-group-element">
									<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width" appearance="fill">
										<mat-label i18n="Brandshare Instance URL (Optional)@@adminDataSourceBrandshareInstanceUrlOptionalLabel">Instance URL (Optional)</mat-label>
										<input matInput formControlName="baseUrl" placeholder="https://cce.brandsharedam.com (default)" i18n-placeholder="Brandshare Instance URL Optional Placeholder@@adminDataSourceBrandshareInstanceUrlOptionalPlaceholder"/>
									</mat-form-field>
								</div>
							</div>
							<div class="admin-data-source-dialog__group" *ngSwitchCase="DataSourceConnectorType.Box">
								<div class="form-group-element">
									<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width mb-5" appearance="fill">
										<mat-label i18n="Box Folder ID (Optional)@@adminDataSourceBoxFolderIdLabel">Folder ID (Optional)</mat-label>
										<input matInput formControlName="target" placeholder="0 (root folder)" i18n-placeholder="Box Folder ID Placeholder@@adminDataSourceBoxFolderIdPlaceholder"/>
										<mat-hint i18n="Box Folder ID Hint@@adminDataSourceBoxFolderIdHint">Leave empty to search all folders, or enter a specific folder ID to search recursively within that folder and all subfolders</mat-hint>
									</mat-form-field>
								</div>
								<div class="form-group-element">
									<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width mb-4" appearance="fill">
										<mat-label i18n="Client ID (Optional)@@adminDataSourceBoxClientIdLabel">Client ID (Optional)</mat-label>
										<input matInput formControlName="clientId" placeholder="Your Box Client ID (leave empty for JWT auth)" i18n-placeholder="Box Client ID Placeholder@@adminDataSourceBoxClientIdPlaceholder"/>
										<mat-hint i18n="Box Client ID Hint@@adminDataSourceBoxClientIdHint">Leave empty to use JWT authentication from environment variables</mat-hint>
									</mat-form-field>
									<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width mb-4" appearance="fill">
										<mat-label i18n="Access Token (Optional)@@adminDataSourceBoxAccessTokenLabel">Access Token (Optional)</mat-label>
										<input matInput type="password" formControlName="accessToken" placeholder="Your Box Enterprise Access Token (leave empty for JWT auth)" i18n-placeholder="Box Access Token Placeholder@@adminDataSourceBoxAccessTokenPlaceholder"/>
										<mat-hint i18n="Box Access Token Hint@@adminDataSourceBoxAccessTokenHint">Leave empty to use JWT authentication from environment variables</mat-hint>
									</mat-form-field>
								</div>
								<div class="form-group-element">
									<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width" appearance="fill">
										<mat-label i18n="Base URL (Optional)@@adminDataSourceBoxBaseUrlOptionalLabel">Base URL (Optional)</mat-label>
										<input matInput formControlName="baseUrl" placeholder="https://api.box.com/2.0 (default)" i18n-placeholder="Box Base URL Optional Placeholder@@adminDataSourceBoxBaseUrlOptionalPlaceholder"/>
									</mat-form-field>
									<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width" appearance="fill">
										<mat-label i18n="Enterprise ID (Optional)@@adminDataSourceBoxEnterpriseIdOptionalLabel">Enterprise ID (Optional)</mat-label>
										<input matInput formControlName="enterpriseId" placeholder="Your Box Enterprise ID" i18n-placeholder="Box Enterprise ID Optional Placeholder@@adminDataSourceBoxEnterpriseIdOptionalPlaceholder"/>
								</mat-form-field>
							</div>
							<div class="form-group-element">
								<app-toggle-input
									[currentValue]="form.get('config').get('saveToLibrary').value"
									label="Save to Library"
									i18n-label="Save to Library Label@@creatorDataSourceSaveToLibraryLabel"
									hint="Automatically save selected assets to our own library"
									i18n-hint="Save to Library Hint@@creatorDataSourceSaveToLibraryHint"
									(valueChange)="form.get('config').get('saveToLibrary').setValue($event)"
								></app-toggle-input>
							</div>
						</div>
						<div class="admin-data-source-dialog__group" *ngSwitchCase="DataSourceConnectorType.AssetCollection">
							<div class="form-group-element">
								<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width mb-5" appearance="fill">
									<mat-label i18n="Asset Collection ID@@adminDataSourceAssetCollectionIdLabel">Asset Collection ID</mat-label>
									<input matInput formControlName="target" placeholder="Asset Collection slug or ID" i18n-placeholder="Asset Collection ID Placeholder@@adminDataSourceAssetCollectionIdPlaceholder"/>
									<mat-hint i18n="Asset Collection ID Hint@@adminDataSourceAssetCollectionIdHint">Enter the slug or ID of the asset collection to use as a data source</mat-hint>
								</mat-form-field>
							</div>
							<div class="form-group-element">
								<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width mb-4" appearance="fill">
									<mat-label i18n="Asset Path Property (Optional)@@adminDataSourceAssetPathPropertyLabel">Asset Path Property (Optional)</mat-label>
									<input matInput formControlName="assetPathProperty" placeholder="assetPath (default)" i18n-placeholder="Asset Path Property Placeholder@@adminDataSourceAssetPathPropertyPlaceholder"/>
									<mat-hint i18n="Asset Path Property Hint@@adminDataSourceAssetPathPropertyHint">Property name to use for the asset path (defaults to 'assetPath')</mat-hint>
								</mat-form-field>
								<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input full-width mb-4" appearance="fill">
									<mat-label i18n="Asset Title Property (Optional)@@adminDataSourceAssetTitlePropertyLabel">Asset Title Property (Optional)</mat-label>
									<input matInput formControlName="assetTitleProperty" placeholder="title (default)" i18n-placeholder="Asset Title Property Placeholder@@adminDataSourceAssetTitlePropertyPlaceholder"/>
									<mat-hint i18n="Asset Title Property Hint@@adminDataSourceAssetTitlePropertyHint">Property name to use for the asset title (defaults to 'title')</mat-hint>
								</mat-form-field>
							</div>
						</div>
					</ng-container>

					<div class="admin-data-source-dialog__group mt-2">
						<span class="admin-data-source-dialog__title" i18n="Context Title@@adminDataSourceContextTitle">Context</span>
							<span class="admin-data-source-dialog__subtitle" i18n="Context Subtitle@@adminDataSourceContextSubtitle">Optional</span>
						</div>

						<div class="admin-data-source-dialog__group">
							<div class="admin-data-source-dialog__group mb-4" formGroupName="context">
								<div *ngFor="let size of context?.controls; index as index" [formGroupName]="index" class="form-group-element">
									<mat-form-field class="no-underline form-field dark-color admin-data-source-dialog__input full-width" floatLabel="never" appearance="fill">
										<mat-select formControlName="context" required>
											<mat-option *ngFor="let context of DataSourceContext | keyvalue" [value]="context.value">{{ context.key }}</mat-option>
										</mat-select>
									</mat-form-field>
									<div class="actions">
										<mat-icon class="cursor-pointer p-2 primary-color" (click)="removeContext(index)">delete</mat-icon>
									</div>
								</div>

								<div class="mt-2">
									<button mat-button color="primary" class="size-small" (click)="addContext()">
										<mat-icon inline>add</mat-icon>
										<ng-container i18n="Add context button@@adminDataSourceAddContextButton">Add context</ng-container>
									</button>
								</div>
							</div>
						</div>

						<div *ngIf="form.get('config.assetPathProperty')" class="admin-data-source-dialog__group">
							<div class="admin-data-source-dialog__group mb-4">

								<div class="form-group-element">
									<app-select-input
										class="block full-width"
										label="Asset Path Property (Optional)"
										[currentValue]="currentDataSource?.config?.assetPathProperty"
										optionLabelKey="path"
										optionValueKey="path"
										[fullWidth]="true"
										placeholder="Select the asset path property"
										(valueChange)="form.get('config').get('assetPathProperty').setValue($event)"
										[options]="form.value.config.mapping"
									></app-select-input>

									<app-select-input
										class="block full-width"
										label="Asset Title Property (Optional)"
										[currentValue]="currentDataSource?.config?.assetTitleProperty"
										optionLabelKey="path"
										optionValueKey="path"
										[fullWidth]="true"
										placeholder="Select the asset title property"
										(valueChange)="form.get('config').get('assetTitleProperty').setValue($event)"
										[options]="form.value.config.mapping"
									></app-select-input>
								</div>

							</div>
						</div>

						<div class="admin-data-source-dialog__group">
							<span class="admin-data-source-dialog__title" i18n="Query parameters Title@@adminDataSourceQueryParametersTitle">Query parameters</span>
							<span class="admin-data-source-dialog__subtitle" i18n="Query parameters Subtitle@@adminDataSourceQueryParametersSubtitle">Optional</span>
						</div>

						<div class="admin-data-source-dialog__group">
							<mat-form-field class="no-underline form-field dark-color admin-data-source-dialog__input full-width" floatLabel="never" appearance="fill">
								<textarea matInput rows="3" cols="20" formControlName="params" placeholder="Enter the query parameters json here" i18n-placeholder="Query parameters Placeholder@@adminDataSourceQueryParametersPlaceholder"></textarea>
							</mat-form-field>
						</div>

						<div class="admin-data-source-dialog__group mt-2">
							<span class="admin-data-source-dialog__title" i18n="Mapping Title@@adminDataSourceMappingTitle">Mapping</span>
							<span class="admin-data-source-dialog__subtitle" i18n="Mapping Subtitle@@adminDataSourceMappingSubtitle">Optional</span>
						</div>

						<div class="toolbar">
							<button *ngIf="currentDataSource" mat-flat-button color="primary" (click)="generateMappings()" i18n="Generate Mappings Button@@adminDataSourceGenerateMappingsButtonLabel">Generate Mappings</button>
						</div>


						<div class="admin-data-source-dialog__group mb-4" formGroupName="mapping">
							<div *ngFor="let size of mapping?.controls; index as index" [formGroupName]="index" class="form-group-element">
								<mat-form-field class="form-field dark-color no-min-width no-label" appearance="fill">
									<mat-label i18n="Path Label@@adminDataSourcePathLabel">Path</mat-label>
									<input matInput formControlName="path" placeholder="Path" i18n-placeholder="Path Placeholder@@adminDataSourcePathPlaceholder"/>
								</mat-form-field>
								<mat-form-field class="form-field dark-color no-min-width no-label" appearance="fill">
									<mat-label i18n="Display Name Label@@adminDataSourceDisplayNameLabel">Display Name</mat-label>
									<input matInput formControlName="displayName" placeholder="Display Name" i18n-placeholder="Display Name Placeholder@@adminDataSourceDisplayNamePlaceholder"/>
								</mat-form-field>
								<mat-form-field class="no-underline form-field dark-color admin-data-source-dialog__input" floatLabel="never" appearance="fill">
									<mat-label i18n="Format Label@@adminDataSourceFormatLabel">Format</mat-label>
									<mat-select formControlName="format" required>
										<mat-option *ngFor="let format of ItemFormat | keyvalue" [value]="format.value">{{ format.key }}</mat-option>
									</mat-select>
								</mat-form-field>
								<div class="actions">
									<mat-icon class="cursor-pointer p-2 primary-color" (click)="removeMapping(index)">delete</mat-icon>
								</div>

							</div>

							<div class="mt-2">
								<button mat-button color="primary" class="size-small" (click)="addMapping()">
									<mat-icon inline>add</mat-icon>
									<ng-container i18n="Add Mapping Button@@adminDataSourceAddMappingButton">
										Add Mapping
									</ng-container>
								</button>
							</div>
						</div>

						<div class="admin-data-source-dialog__group">
							<span class="admin-data-source-dialog__title" i18n="Sortable fields Title@@adminDataSourceSortableFieldsTitle">Sortable fields</span>
							<span class="admin-data-source-dialog__subtitle" i18n="Sortable fields Subtitle@@adminDataSourceSortableFieldsSubtitle">Optional</span>
						</div>

						<div class="admin-data-source-dialog__group mb-4" formGroupName="sortableFields">
							<div *ngFor="let size of sortableFields?.controls; index as index" [formGroupName]="index" class="form-group-element">
								<mat-form-field class="form-field dark-color no-min-width no-label" appearance="fill">
									<mat-label i18n="Path Label@@adminDataSourcePathLabel">Path</mat-label>
									<input matInput formControlName="path" placeholder="Path" i18n-placeholder="Path Placeholder@@adminDataSourcePathPlaceholder"/>
								</mat-form-field>
								<mat-form-field class="form-field dark-color no-min-width no-label" appearance="fill">
									<mat-label i18n="Display Name Label@@adminDataSourceDisplayNameLabel">Display Name</mat-label>
									<input matInput formControlName="displayName" placeholder="Display Name" i18n-placeholder="Display Name Placeholder@@adminDataSourceDisplayNamePlaceholder"/>
								</mat-form-field>
								<div class="actions">
									<mat-icon class="cursor-pointer p-2 primary-color" (click)="removeSortableField(index)">delete</mat-icon>
								</div>
							</div>

							<div class="mt-2">
								<button mat-button color="primary" class="size-small" (click)="addSortableField()">
									<mat-icon inline>add</mat-icon>
									<ng-container i18n="Add Sortable field Button@@adminDataSourceAddSortableFieldButton">
										Add Sortable field
									</ng-container>
								</button>
							</div>
						</div>

						<div class="admin-data-source-dialog__group">
							<span class="admin-data-source-dialog__title" i18n="Filters Title@@adminDataSourceFiltersTitle">Filters</span>
							<span class="admin-data-source-dialog__subtitle" i18n="Filters Subtitle@@adminDataSourceFiltersSubtitle">Optional</span>
						</div>

						<div class="admin-data-source-dialog__group mb-4" formGroupName="filters">
							<ng-container *ngFor="let filter of filters?.controls; index as index" [formGroupName]="index">
								<div class="form-group-element">
									<mat-form-field class="form-field dark-color no-min-width no-label" appearance="fill">
										<mat-label i18n="ID Label@@adminDataSourceIDLabel">ID</mat-label>
										<input matInput formControlName="id" placeholder="ID" i18n-placeholder="ID Placeholder@@adminDataSourceIDPlaceholder"/>
									</mat-form-field>
									<mat-form-field class="form-field dark-color no-min-width no-label" appearance="fill">
										<mat-label i18n="Name Label@@adminDataSourceNameLabel">Name</mat-label>
										<input matInput formControlName="name" placeholder="Name" i18n-placeholder="Name Placeholder@@adminDataSourceNamePlaceholder"/>
									</mat-form-field>

								</div>

								<div class="form-group-element">
									<mat-form-field class="form-field dark-color no-min-width no-label" appearance="fill">
										<mat-label i18n="ParamKey Label@@adminDataSourceParamKeyLabel">ParamKey</mat-label>
										<input matInput formControlName="paramKey" placeholder="ParamKey" i18n-placeholder="ParamKey Placeholder@@adminDataSourceParamKeyPlaceholder"/>
									</mat-form-field>
									<mat-form-field class="form-field dark-color no-min-width no-label" appearance="fill">
										<mat-label i18n="Category Label@@adminDataSourceCategoryLabel">Category</mat-label>
										<input matInput formControlName="category" placeholder="Category" i18n-placeholder="Category Placeholder@@adminDataSourceCategoryPlaceholder"/>
									</mat-form-field>
								</div>

								<div class="form-group-element">
									<mat-form-field class="form-field dark-color no-min-width no-label" appearance="fill">
										<mat-label i18n="Type Label@@adminDataSourceTypeLabel">Type</mat-label>
										<mat-select formControlName="type" required>
											<mat-option *ngFor="let type of (FilterType | keyvalue)" [value]="type.value">{{ getFilterTypeTitle(type.value) }}</mat-option>
										</mat-select>
									</mat-form-field>
									<mat-form-field class="form-field dark-color no-min-width no-label" appearance="fill">
										<mat-label i18n="Layout Label@@adminDataSourceLayoutLabel">Layout</mat-label>
										<mat-select formControlName="layout" required>
											<mat-option *ngFor="let layout of (FilterLayout | keyvalue)" [value]="layout.value">{{ layout.key }}</mat-option>
										</mat-select>
									</mat-form-field>
									<mat-form-field class="form-field dark-color no-min-width no-label" appearance="fill">
										<mat-label i18n="Order Label@@adminDataSourceOrderLabel">Order</mat-label>
										<input matInput formControlName="order" placeholder="Order" i18n-placeholder="Order Label@@adminDataSourceOrderLabel"/>
									</mat-form-field>
								</div>

								<div class="form-group-element">
									<mat-slide-toggle formControlName="grow" color="primary" i18n="Grow Label@@adminDataSourceGrowLabel">Grow</mat-slide-toggle>
									<mat-slide-toggle formControlName="topPadding" color="primary" i18n="Top Padding Label@@adminDataSourceTopPaddingLabel">Top Padding</mat-slide-toggle>
								</div>

								<div class="actions">
									<mat-icon class="cursor-pointer p-2 primary-color" (click)="removeFilter(index)">delete</mat-icon>
								</div>
							</ng-container>

							<div class="mt-2">
								<button mat-button color="primary" class="size-small" (click)="addFilter()">
									<mat-icon inline>add</mat-icon>
									<ng-container i18n="Add Filter Button@@adminDataSourceAddFilterButton">
										Add Filter
									</ng-container>
								</button>
							</div>
						</div>

						<div class="admin-data-source-dialog__group mt-2">
							<span class="admin-data-source-dialog__title" i18n="Preview path Title@@adminDataSourcePreviewPathTitle">Preview path</span>
							<span class="admin-data-source-dialog__subtitle" i18n="Preview path Subtitle@@adminDataSourcePreview pathSubtitle">Optional</span>
						</div>

						<div class="admin-data-source-dialog__group">
							<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input" appearance="fill">
								<mat-label i18n="Preview path Label@@adminDataSourcePreviewPathLabel">Preview path</mat-label>
								<input matInput formControlName="previewPath"/>
							</mat-form-field>
						</div>

						<div class="admin-data-source-dialog__group mt-2">
							<span class="admin-data-source-dialog__title" i18n="Tag path Title@@adminDataSourceTagPathTitle">Tag path</span>
							<span class="admin-data-source-dialog__subtitle" i18n="Tag path Subtitle@@adminDataSourceTagPathSubtitle">Optional</span>
						</div>

						<div class="admin-data-source-dialog__group">
							<mat-form-field class="form-control form-field dark-color no-background admin-data-source-dialog__input" appearance="fill">
								<mat-label i18n="Tag path Label@@adminDataSourceTagPathLabel">Tag path</mat-label>
								<input matInput formControlName="tagPath"/>
							</mat-form-field>
						</div>
					</ng-container>
				</div>
			</div>
		</mat-tab>
		<mat-tab label="Code" i18n-label="External Data Sources Tab Code Label@@adminExternalDataSourcesViewCodeLabel">
			<div class="mt-6">
				<app-monaco-input
					*ngIf="currentTabIndex === 1"
					[currentValue]="formCache"
					language="json"
					[fullWidth]="true"
					(valueChange)="onSetCodeCache($event)"
				></app-monaco-input>
			</div>
		</mat-tab>
		<mat-tab label="Import/Export" i18n-label="External Data Sources Tab Import Export Label@@adminExternalDataSourcesImportExportLabel">
			<div class="mt-6">
				<button *ngIf="currentDataSource" mat-flat-button color="primary" (click)="onExport()" class="mr-2">
					<mat-icon>download</mat-icon>
					<ng-container i18n="Export Data Source Button@@adminDataSourceExportButton">
						Export data source
					</ng-container>
				</button>

				<button mat-flat-button color="primary" (click)="onImport()">
					<mat-icon>upload</mat-icon>
					<ng-container i18n="Import Data Source Button@@adminDataSourceImportButton">
						Import data source
					</ng-container>
				</button>
			</div>
		</mat-tab>
	</mat-tab-group>
  </div>

  <div mat-dialog-actions class="pt-5 pb-3">
	<div class="mb-4">
		<div class="form-error-container mt-4" *ngIf="!form?.valid">
			<mat-icon class="mr-1">clear</mat-icon>
			<span i18n="Required fields not valid Message@@adminDataSourceRequiredFieldsNotValidMessage">Required fields not valid.</span>
		</div>
	</div>

	<button *ngIf="!inline" class="margin-left-auto admin-data-source-dialog__button secondary-button" color="secondary" mat-button (click)="dialogRef ? dialogRef.close(false) : close.emit(false)" i18n="Dialog Action Button@@adminDataSourceCancelButtonLabel">
		Cancel
	</button>
	<button mat-flat-button color="primary" [disabled]="!form.valid" class="remove button-extra-small admin-data-source-dialog__button" (click)="submit()">
		<ng-container *ngIf="inline; else dialogModeLabel" i18n="Dialog Action Button@@adminDataSourceSaveButtonLabel">Save</ng-container>
		<ng-template #dialogModeLabel>
			<ng-container *ngIf="currentDataSource; else addLabel" i18n="Dialog Action Button@@adminDataSourceUpdateButtonLabel">Update Source</ng-container>
			<ng-template #addLabel>
				<ng-container i18n="Dialog Action Button@@adminDataSourceAddButtonLabel">Add Source</ng-container>
			</ng-template>
		</ng-template>
	</button>
  </div>
</div>
